import { render, staticRenderFns } from "./SidebarMenu.html?vue&type=template&id=44d5ff95&scoped=true&external"
import script from "./SidebarMenu.ts?vue&type=script&lang=ts&external"
export * from "./SidebarMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./SidebarMenu.scss?vue&type=style&index=0&id=44d5ff95&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d5ff95",
  null
  
)

export default component.exports